import { TFunction } from 'i18next';
import * as yup from 'yup';

export const getForgotPasswordSchema = (t: TFunction) =>
    yup.object({}).shape({
        email: yup.string().email(t('form:invalidEmail')).required(t('form:requiredField')),
    });
